import { route } from '../helpers';
import { LoginPages } from '../../constants/AppConstants';
import FeatureFlagStore from '../../stores/FeatureFlagStore';
import UserStore from '../../stores/UserStore';
import CustomerActions from '../../actions/CustomerActions';

import SetPasswordAndPreferences from '../../components/login/SetPasswordAndPreferences';

const showPage = FeatureFlagStore.get('enableSetPasswordAndPreferencesPage');

module.exports = showPage ? route(LoginPages.SET_PASSWORD_AND_PREFERENCES, {
    getComponent(location, cb) {
        require.ensure([], () => {
            cb(null, SetPasswordAndPreferences);
        }, 'login-set-password-and-preferences');
    },

    async onEnter () {
        const user = UserStore.getCurrent();

        if (user && user.isLoggedIn()) {
            await CustomerActions.logout(UserStore.getCurrent());
        }
    }
}) : null;



// WEBPACK FOOTER //
// ./src/routes/Login/SetPasswordAndPreferences.js